import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Outlet,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import EmailVerification from "./pages/EmailVerification";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout";
import "./styles/App.css";
import "./styles/InputSheet.css";
import "react-toastify/dist/ReactToastify.css";
import Profile from "./pages/Profile/Profile";
import OEMPartners from "./pages/OEMPartners/OEMPartners";
import Setting from "./pages/Settings/Setting";
import NotFound from "./pages/NotFound";
import Scan from "./pages/SingleScan/Scan";
import OEMUserDetail from "./pages/OEMPartners/OEMUserDetail";

function App() {
  const profileState = useSelector((state) => state.profile);
  const profileReducer = profileState?.data;

  const { isAuthenticated } = useSelector((state) => state.auth);
  const logo = profileReducer?.logo;

  // Set favicon based on authentication status
  const faviconUrl =
    isAuthenticated && logo
      ? logo
      : "https://washi.s3.ap-south-1.amazonaws.com/RR360%20with%20whitebg.png";

  return (
    <Router
    // basename={process.env.REACT_APP_BASE_PATH || "/itsales"}
    >
      <Helmet>
        <link
          rel="icon"
          type="image/png"
          href={faviconUrl}
          sizes="16x16 32x32"
        />
        <link rel="shortcut icon" type="image/x-icon" href={faviconUrl} />
      </Helmet>

      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/login/verify" element={<EmailVerification />} />
        <Route path="/verify" element={<EmailVerification />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path="oem-partners" element={<OEMPartners />} />
          <Route path="settings" element={<Setting />} />
          <Route path="scan" element={<Scan />} />
          <Route path="oem-user-details" element={<OEMUserDetail />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        limit={5}
        style={{ width: "320px" }}
        toastStyle={{ paddingRight: "40px" }}
      />
    </Router>
  );
}

export default App;
